import { Fee } from '@kinet-open-network/client/fees/data-access';
import {
  FeeType,
  IServPackageFee,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class ServPackageFee implements IServPackageFee {
  id!: string;

  servPackageId!: string;

  feeId!: string;

  type!: FeeType;

  @Type(() => Fee)
  fee?: Fee;
}
